import { authAPI } from './api';

class AuthService {
  static async login(email, password) {
    try {
      const response = await authAPI.login({ email, password });
      
      if (response.success && response.token) {
        // Store token and user data
        localStorage.setItem('token', response.token);
        localStorage.setItem('userRole', response.user.role);
        localStorage.setItem('user', JSON.stringify(response.user));
        
        // Store department_id if available
        if (response.user.department_id) {
          localStorage.setItem('department_id', response.user.department_id);
          console.log('🔑 Department ID stored:', response.user.department_id);
        } else {
          console.warn('⚠️ Department ID not found in login response for user:', response.user.email);
        }
        
        console.log('✅ Login successful. User data:', response.user);
        
        return {
          success: true,
          user: response.user
        };
      }
      
      return {
        success: false,
        message: response.message || 'Login failed'
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Login failed'
      };
    }
  }

  static async register(username, email, password, role) {
    try {
      const response = await authAPI.register({ username, email, password, role });
      
      return {
        success: response.success,
        message: response.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Registration failed'
      };
    }
  }

  static async getProfile() {
    try {
      const response = await authAPI.getProfile();
      
      if (response.success) {
        return {
          success: true,
          user: response.data
        };
      }
      
      return {
        success: false,
        message: response.message || 'Failed to get profile'
      };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to get profile'
      };
    }
  }

  static logout() {
    authAPI.logout();
    window.location.href = '/login';
  }

  static isAuthenticated() {
    return !!localStorage.getItem('token');
  }

  static getUserRole() {
    return localStorage.getItem('userRole');
  }

  static getDepartmentId() {
    const deptId = localStorage.getItem('department_id');
    return deptId ? parseInt(deptId) : null;
  }

  static getUser() {
    const userStr = localStorage.getItem('user');
    const user = userStr ? JSON.parse(userStr) : null;
    
    // If department_id not in user object, get from localStorage
    if (user && !user.department_id && localStorage.getItem('department_id')) {
      user.department_id = parseInt(localStorage.getItem('department_id'));
    }
    
    return user;
  }

  static isAdmin() {
    return this.getUserRole() === 'admin';
  }
}

export default AuthService;
